import { LinkTo } from 'shared/constants/linkTo';

export type FindLmsSearchTabKey = 'projects' | 'people';

export const LMS_DESIGNER_SEARCH_GLOBAL_TYPES = [
  'Employee',
  'HseDesignEmployee',
  'Student',
  'HseDesignStudent',
  'Cooperator',
  'hsealumni',
  'externalhse',
  'DPO',
  'BAK',
  'MAG',
  'Exstudent',
  'Hsepermstudent',
  'hsepermstudent',
] as const;

/** URL страницы поиска LMS (курсы + люди). */
export const getFindLmsSearchPageUrl = (
  search?: string,
  tab?: FindLmsSearchTabKey,
): string => {
  const params = new URLSearchParams();
  if (search?.trim()) {
    params.set('search', search.trim());
  }
  if (tab) {
    params.set('tab', tab);
  }
  const query = params.toString();
  return query ? `${LinkTo.findLms}?${query}` : LinkTo.findLms;
};
import { LinkTo } from 'shared/constants/linkTo';

export type FindLmsSearchTabKey = 'projects' | 'people';

export const LMS_DESIGNER_SEARCH_GLOBAL_TYPES = [
  'Employee',
  'HseDesignEmployee',
  'Student',
  'HseDesignStudent',
  'Cooperator',
  'hsealumni',
  'externalhse',
  'DPO',
  'BAK',
  'MAG',
  'Exstudent',
  'Hsepermstudent',
  'hsepermstudent',
] as const;

/** URL страницы поиска LMS (курсы + люди). */
export const getFindLmsSearchPageUrl = (
  search?: string,
  tab?: FindLmsSearchTabKey,
): string => {
  const params = new URLSearchParams();
  if (search?.trim()) {
    params.set('search', search.trim());
  }
  if (tab) {
    params.set('tab', tab);
  }
  const query = params.toString();
  return query ? `${LinkTo.findLms}?${query}` : LinkTo.findLms;
};
